<!--
  * name: AccountMenu
  * description: 계정 관련 메뉴 컴포넌트
-->
<template>
  <!-- <ul class="util-menu-ul" :class="menuClasses"> -->
  <ul class="util-menu-ul">
    <li v-for="menu in menuList" :key="menu.name" :class="menuClasses">
      <a :href="menu.url" :class="menu.classes" target="_blank">{{menu.name}}</a>
    </li>
    <li class="top-srch-btn">
      <a
        v-show="showSearchBtn"
        href="javascript:void(0);"
        @click="openSrch"
        aria-current="page"
        class="router-link-exact-active router-link-active btn-srch"
        :class="{ togg: isSrchOpen }"
        >검색</a
      >
    </li>
  </ul>
</template>

<script>
export default {
  name: 'AccountMenu',
  props: {
    isPC: {
      // PC/Mobile 여부 Flag
      type: Boolean,
      required: true,
    },
    isSrchOpen: {
      type: Boolean,
      default: false,
    },
    showMobileMenu: { // 모바일 메뉴 오픈 여부 Flag
      type: Boolean,
      required: true,
    },
  },
  computed: {
    menuClasses() {
      return {
        'util-menu-ul': this.isPC,
        'hide-mobile': this.isPC,
      };
    },
    menuList() {
      return [
        // 메뉴 리스트
        { name: '매장찾기', classes: ['btn-branch'], url: `${process.env.VUE_APP_RIMAN_URL}/branch` },
        { name: '신규회원가입', classes: ['btn-join'], url: 'https://myoffice.rimankorea.com/member/join' },
        { name: '회원전용몰', classes: ['btn-mall'], url: 'https://myoffice.rimankorea.com' },
        // { name: '검색', classes: ['btn-srch'], url: '' },
      ];
    },
    showSearchBtn() {
      if (this.$route.path === '/search') {
        return false;
      }
      return true;
    },
  },
  methods: {
    openSrch() {
      this.$emit('toggle-srch', !this.isSrchOpen);
    },
  },
};
</script>
